export default __webpack_public_path__ + "static/media/PU-Sandwich-Panel(2).9a281b46.jpg";